import React from 'react';
import { ViewOptions } from './PropertyDetailsViewSelect';
import { PropertyDataProps, PropertyImage } from '../../utility/types';
import StreetViewer from '../common/StreetViewer';
import NearbyListingMap from '../common/maps/NearbyListingsMap';
import { GridImageViewer } from '../common/GridImageViewer';

type PropertyMapOrImagesProps = {
  activeView: ViewOptions;
  property: PropertyDataProps;
  mlsImages: PropertyImage[];
};

export const PropertyMapOrImages = ({
  activeView,
  property,
  mlsImages,
}: PropertyMapOrImagesProps) => {
  const content = () => {
    switch (activeView) {
      case ViewOptions.images:
        return <GridImageViewer propertyImages={mlsImages} />;
      case ViewOptions.map:
        return (
          <NearbyListingMap property={property} showNearbyProperties={false} />
        );
      case ViewOptions.streetView:
        return <StreetViewer property={property} />;
    }
  };

  return (
    <div className="h-[30rem] w-full">
      {content()}
      <hr className="h-1.5 bg-violet-100" />
    </div>
  );
};
